import Vue from 'vue'
import store from './store'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate';
import LazyLoad from "vanilla-lazyload";
window.lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
})
import dutch from 'vee-validate/dist/locale/nl';
Vue.use(VeeValidate, {
    dictionary: {
        locale: 'en',
        nl: { messages: dutch.messages},
    }
});
Vue.use(VueCookies)
Vue.use(VueLazyload)
Vue.use(VueScrollTo)

VueCookies.config('365d')
Vue.config.devtools = true
Vue.component('models', require('./components/Models.vue').default)
Vue.component('application', require('./components/Application.vue').default)
Vue.component('application-finish', require('./components/ApplicationFinish.vue').default)
require('./mixins')

new Vue({
    el: '#talents',
    store,
    router
});
